<template>
  <div class="contract-table">
    <!--新增/删除按钮-->
    <vxe-toolbar size="mini" v-if="!isHiddenBtn">
      <template v-slot:buttons>
        <template>
          <el-button type="primary" size="small" class="vxe-btn-primary" @click="addNewRowHandler"
            >新增</el-button
          >
          <el-button
            size="small"
            type="danger"
            class="vxe-btn-delete"
            @click="deleteBtnClickHandler()"
            >删除</el-button
          >
        </template>
      </template>
    </vxe-toolbar>
    <!---可编辑表格-->
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xTableRef"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
      :columns="tableColumnsList"
      :edit-rules="tableRules"
      :edit-config="editConfig"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :show-footer="true"
      :footer-method="footerMethod"
      @select-change="handleSelectionChange"
      @select-all="handleSelectionChange"
    >
    </vxe-grid>
  </div>
</template>

<script>
  export default {
    name: 'SpaceRowTable',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
      fetchTableData: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        tableData: [],
        selectionList: [],
        editConfig: { trigger: 'click', mode: 'row' },
        isHiddenBtn: false,
        tableRules: {},
        ids: [], // 被删除的数据id集合
        spaceTypeList: [], // 空间类型
        spaceCategoryList: [], // 空间类别
        spaceStatusList: [], // 空间状态
        chargeCycleList: [], // 计费周期
      };
    },
    computed: {
      tableColumnsList() {
        return [
          { type: 'checkbox', width: 50 },
          { type: 'seq', title: '序号', width: 50 },
          {
            field: 'spaceType',
            title: '空间类型',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: this.spaceTypeList,
            },
            width: 150,
          },
          {
            field: 'spaceCategory',
            title: '空间类别',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: this.spaceCategoryList,
            },
            width: 150,
          },
          {
            field: 'builtArea',
            title: '建筑面积',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                placeholder: '请输入仓库地址',
              },
              // events: {
              //   // change: (obj) => this.updateCol(obj.row, obj.row['builtArea'], 'builtArea'),
              //   input: (obj) => this.updateCol(obj.row, obj.row['builtArea'], 'builtArea'),
              // onInput={(val) => this.chooseTable(val, row, 'serviceCycle')}
              // },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['builtArea']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['builtArea']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'builtArea')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'spaceStatus',
            title: '空间状态',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: this.spaceStatusList,
            },
            width: 150,
          },
          {
            field: 'chargeUnitPrice',
            title: '计费单价',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
              // events: {
              //   input: (obj) =>
              //     this.updateCol(obj.row, obj.row['chargeUnitPrice'], 'chargeUnitPrice'),
              // },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['chargeUnitPrice']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['chargeUnitPrice']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'chargeUnitPrice')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'totalPrice',
            title: '总价',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
          },
          // {
          //   field: 'totalBuiltArea',
          //   title: '总建筑面积',
          //   editRender: {
          //     name: 'ElInput',
          //     props: {
          //       clearable: true,
          //     },
          //   },
          //   width: 150,
          // },
          {
            field: 'chargeCycle',
            title: '计费周期',
            editRender: {
              name: 'ElSelect',
              props: {
                clearable: true,
              },
              options: this.chargeCycleList,
            },
            width: 150,
          },
          {
            field: 'cycleNum',
            title: '服务周期数',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
              // events: {
              //   input: (obj) => this.updateCol(obj.row, obj.row['cycleNum'], 'cycleNum'),
              // },
            },
            slots: {
              default: ({ row }) => {
                return [<span>{row['cycleNum']}</span>];
              },
              edit: ({ row }) => {
                return [
                  <InputNumberAd
                    value={row['cycleNum']}
                    max={999999999.999999}
                    min={0}
                    precision={6}
                    onInput={(val) => this.updateCol(row, val, 'cycleNum')}
                  ></InputNumberAd>,
                ];
              },
            },
            width: 150,
          },
          {
            field: 'eachIssuePrice',
            title: '每期费用',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
                disabled: true,
              },
            },
            width: 150,
          },
          {
            field: 'remark',
            title: '备注',
            editRender: {
              name: 'ElInput',
              props: {
                clearable: true,
              },
            },
            width: 150,
          },
        ];
      },
    },
    mounted() {
      this.spaceTypeList = this.dictListMap.LeaseContractSpaceType; // 空间类型
      this.spaceCategoryList = this.dictListMap.LeaseContractSpaceCategory; // 空间类别
      this.spaceStatusList = this.dictListMap.LeaseContractSpaceStatus; // 状态
      this.chargeCycleList = this.dictListMap.LeaseContractChargeCycle; // 计费周期
    },
    methods: {
      // 表格底部
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['builtArea'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.builtArea, 0).toFixed(6);
            }
            if (['totalPrice'].includes(column.property)) {
              return data.reduce((cur, next) => cur + +next.totalPrice, 0).toFixed(2);
            }
            return '-';
          }),
        ];
      },
      // 更新列
      updateCol(row, fieldValue, field) {
        console.log(row, fieldValue, field, '====>');
        row[field] = fieldValue;
        if (field == 'builtArea') {
          row['totalPrice'] = (
            fieldValue * (row['chargeUnitPrice'] ? row['chargeUnitPrice'] : 0)
          ).toFixed(2);
          row['eachIssuePrice'] = row['cycleNum']
            ? (row['totalPrice'] / row['cycleNum']).toFixed(2)
            : 0;
        } else if (field == 'chargeUnitPrice') {
          row['totalPrice'] = (fieldValue * (row['builtArea'] ? row['builtArea'] : 0)).toFixed(2);
          row['eachIssuePrice'] = row['cycleNum']
            ? (row['totalPrice'] / row['cycleNum']).toFixed(2)
            : 0;
        } else if (field == 'cycleNum') {
          row['eachIssuePrice'] = fieldValue ? (row['totalPrice'] / fieldValue).toFixed(2) : 0;
        }
      },
      handleSelectionChange(row) {
        this.selectionList = row.selection;
      },
      // 新增一行
      async addNewRowHandler() {
        const $table = this.$refs.xTableRef;
        const { row } = await $table.insertAt({}, 0);
        await $table.setActiveRow(row);
      },
      // 删除行
      deleteBtnClickHandler() {
        if (!this.selectionList.length) {
          this.$message.error('请选择行再删除');
          return;
        }
        const XIDList = this.selectionList.map((item) => item._XID);
        const idList = this.selectionList.map((item) => item.id).filter((item) => Boolean(item));
        this.ids = [...this.ids, ...idList];
        this.tableData = this.getTableData().filter((item) => !XIDList.includes(item._XID));
      },
      // 关闭表格
      closeEditTableHandler() {},
      // 获取表格数据
      getValidateTableData() {
        this.closeEditTableHandler();
        return new Promise((resolve) => {
          const $table = this.$refs.xTableRef;
          const tableData = $table.getTableData().fullData;
          console.log('this.ids', this.ids, '一改');
          $table.validate((valid) => {
            console.log(valid);
            // if (valid && tableData.length) {

            // } else {
            //   this.$message.error('请填写表格数据');
            //   reject({ tableData: [], deleteStorageLineIds: [] });
            // }
            const currentStatus = this.$route.query.status;
            const formTableData = tableData.map((item) => {
              return {
                ...item,
                departmentCode: this.userInfo.departmentCode,
                departmentName: this.userInfo.departmentName,
                companyCode: this.userInfo.companyCode,
                companyName: this.userInfo.companyName,
                // 特殊处理id
                id:
                  ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                    ? ''
                    : item?.id,
              };
            });
            resolve({ tableData: formTableData, deleteSpaceLineIds: this.ids });
          });
        });
      },
      getTableData() {
        const $table = this.$refs.xTableRef;
        return $table.getTableData().fullData;
      },
      fullTableData(tableData) {
        this.tableData = tableData;
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          // 如果当前是续签的时候只有主体不可以编辑就是
          const currentStatus = this.$route.query.status;
          if (['-1'].includes(val)) {
            this.editConfig = {};
            this.isHiddenBtn = true;
          } else if (['renew', 'change'].includes(currentStatus)) {
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else if (['create'].includes(currentStatus)) {
            // 拷贝的时候
            this.editConfig = { trigger: 'click', mode: 'row' };
            this.isHiddenBtn = false;
          } else {
            if (['02', '03', '05', '06'].includes(val)) {
              this.editConfig = {};
              this.isHiddenBtn = true;
            } else {
              this.editConfig = { trigger: 'click', mode: 'row' };
              this.isHiddenBtn = false;
            }
          }
        },
        immediate: true,
      },
      fetchTableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
